import React, { useCallback, useEffect, useRef, useState } from 'react';
import DsModal from '../DsModal';
import { useAnnouncements } from '../../../contexts/AnnouncementContext';
import { formatDateTime, renderBody } from './announcementUtils';
import '../../../css/common/announcements/Announcements.css';

function AnnouncementPopup() {
  const { popupAnnouncements, acknowledgePopup } = useAnnouncements();
  const [detailAnnouncement, setDetailAnnouncement] = useState(null);
  const [listMode, setListMode] = useState(false);
  const acknowledgedIdsRef = useRef(new Set());

  const openDetail = useCallback(
    (announcement) => {
      if (!announcement) return;
      setDetailAnnouncement(announcement);
      const key = String(announcement.id);
      if (!acknowledgedIdsRef.current.has(key)) {
        acknowledgedIdsRef.current.add(key);
        acknowledgePopup(announcement);
      }
    },
    [acknowledgePopup]
  );

  const handleDetailClose = () => {
    setDetailAnnouncement(null);
  };

  useEffect(() => {
    if (detailAnnouncement) return;
    if (!popupAnnouncements.length) {
      setListMode(false);
      return;
    }
    if (popupAnnouncements.length > 1) {
      setListMode(true);
      return;
    }
    if (listMode) return;
    openDetail(popupAnnouncements[0]);
  }, [detailAnnouncement, listMode, openDetail, popupAnnouncements]);

  if (!popupAnnouncements.length && !detailAnnouncement) return null;

  return (
    <>
      {listMode && popupAnnouncements.length > 0 && !detailAnnouncement && (
        <DsModal
          open
          onClose={() => setListMode(false)}
          title="重要なお知らせ"
          size="sm"
          className="announcement-popup"
        >
          <div className="announcement-list">
            {popupAnnouncements.map((announcement) => (
              <button
                key={`popup-announcement-${announcement.id}`}
                type="button"
                className="announcement-row"
                onClick={() => openDetail(announcement)}
              >
                <span className="announcement-row__bullet">・</span>
                <span className="announcement-row__content">
                  <span className="announcement-row__title">{announcement.title}</span>
                </span>
              </button>
            ))}
          </div>
        </DsModal>
      )}
      {detailAnnouncement && (
        <DsModal
          open={Boolean(detailAnnouncement)}
          onClose={handleDetailClose}
          title={detailAnnouncement.title}
          size="lg"
          className="announcement-detail-modal"
        >
          <p className="announcement-detail-modal__date">
            {formatDateTime(detailAnnouncement.publishedAt)}
          </p>
          <div className="announcement-card__body">{renderBody(detailAnnouncement.body)}</div>
        </DsModal>
      )}
    </>
  );
}

export default AnnouncementPopup;
